var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "mb-4"
  }, [_c('b-card-title', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.menu.label.goods-receipt-create')) + " ")]), _c('b-form', {
    staticClass: "mt-4",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleFormSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('label', [_vm._v("Leverancier")]), _c('br')]), _c('b-col', {
    attrs: {
      "sm": "10"
    }
  }, [_vm.isLoadingAvailableLocations ? [_c('span', [_vm._v(" Een moment geduld, de lijst met leveranciers wordt opgehaald. ")]), _c('FontAwesomeIcon', {
    staticClass: "ml-1",
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })] : [_c('b-form-select', {
    attrs: {
      "options": _vm.availableLocations,
      "size": "sm"
    },
    model: {
      value: _vm.form.supplier_identifier,
      callback: function ($$v) {
        _vm.$set(_vm.form, "supplier_identifier", $$v);
      },
      expression: "form.supplier_identifier"
    }
  })]], 2)], 1), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('label', [_vm._v("Referentie")]), _c('br')]), _c('b-col', {
    attrs: {
      "sm": "10"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "size": "sm"
    },
    model: {
      value: _vm.form.identifier,
      callback: function ($$v) {
        _vm.$set(_vm.form, "identifier", $$v);
      },
      expression: "form.identifier"
    }
  })], 1)], 1), _c('b-row', [_c('b-col', [_c('OmniButtonCollection', {
    staticClass: "mt-4",
    attrs: {
      "alignment": "end"
    }
  }, [_c('OmniButton', {
    attrs: {
      "to": {
        name: 'GoodsReceiptIndex'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.cancel')))]), _c('OmniButton', {
    attrs: {
      "type": "submit",
      "disabled": _vm.isCreatingGoodsReceipt || !_vm.isFormValid
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.menu.label.goods-receipt-create')) + " "), _vm.isCreatingGoodsReceipt ? _c('FontAwesomeIcon', {
    staticClass: "ml-1",
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }